import * as React from "react";
import { useTranslation } from "react-i18next";
import { Popup } from "react-map-gl/mapbox";
import { Box, Stack, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import HomeIcon from "@mui/icons-material/Home";

import styles from "./pricesPopup.module.css";
import { formatCurrency } from "../../helpers";

/**
 * @param {Object} props
 * @param {number} props.lat
 * @param {number} props.lng
 * @param {string} props.name
 * @param {number} props.capitalAtRisk
 * @param {number} props.contractPrice
 * @param {number} props.totalProperties
 * @param {function} [props.onClose]
 * @param {string}   [props.currency='EUR']
 */
export default function PricesPopup({
  lat,
  lng,
  name,
  capitalAtRisk,
  contractPrice,
  totalProperties,
  onClose,
}) {
  const { t } = useTranslation();
  return (
    <Popup
      latitude={lat}
      longitude={lng}
      anchor="bottom"
      closeButton
      closeOnClick={false}
      onClose={onClose}
      offset={[0, 10]}
      className={styles.popup}
      maxWidth="600px"
    >
      <Box>
        <Stack spacing={1}>
          <Stack direction="row" spacing={1.2} alignItems="center">
            <LocationOnIcon fontSize="small" color="primary" />
            <Typography variant="body2">
              {name || t("common.noData")}
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1.2} alignItems="center">
            <HomeIcon fontSize="small" color="primary" />
            <Typography variant="body2">
              {t("portfolioMap.totalInsuredProperties")}:{" "}
              <strong>{totalProperties}</strong>
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1.2} alignItems="center">
            <WarningAmberIcon fontSize="small" color="warning" />
            <Typography variant="body2">
              {t("portfolioMap.totalCapitalAtRisk")}:{" "}
              <strong>{formatCurrency(capitalAtRisk ?? 0)}</strong>
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1.2} alignItems="center">
            <MonetizationOnIcon fontSize="small" color="warning" />
            <Typography variant="body2">
              {t("portfolioMap.totalContractPrice")}:{" "}
              <strong>{formatCurrency(contractPrice ?? 0)}</strong>
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Popup>
  );
}
